<template>
  <div class="section contextual-info">
    <div class="customer-information">
      <h3>Customer Information</h3>
      <p><span class="bold">Customer:</span> {{ sampleData.customer.customerName }}</p>
      <p><span class="bold">Attention:</span> {{ firstOrNullAttention }}</p>
      <p><span class="bold">Address:</span> {{ sampleData.customer.address }}</p>
      <p><span class="bold">Email:</span> {{ sampleData.customer.allReportEmails }}</p>
      <p>{{ goodOrBadReportEmails }}</p>
    </div>
    <div class="component-information">
      <h3>Component Information</h3>
      <p><span class="bold">Unit Name:</span> {{ sampleData.unit.unitName }}</p>
      <p><span class="bold">Manufacturer:</span> {{ sampleData.unit.manufacturerModelName }}</p>
      <p><span class="bold">Unit Type:</span> {{ sampleData.unit.unitTypeName }}</p>
      <p><span class="bold">Fluid Name:</span> {{ sampleData.currentOilSample.fluidName }}</p>
    </div>
    <div class="element-key">
      <h3>Element Key</h3>
      <div class="element-table">
        <div class="element" v-for="{ abbreviation, name } in elementList" :key="abbreviation">
          <h4>{{ abbreviation }}</h4>
          <p>{{ name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from '../../../constants/constants';

export default {
  name: 'OilSampleReportContextualInfo',
  props: {
    sampleData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      elementList: Constants.SampleReport.Element.oilSampleElements
    };
  },
  computed: {
    firstOrNullAttention() {
      return this.sampleData.unit.attention || this.sampleData.customer.attention;
    },

    goodOrBadReportEmails() {
      return this.sampleData.currentOilSample.sampleSeverityCode === Constants.Severities.Normal
        ? this.sampleData.customer.goodReportEmails
        : this.sampleData.customer.badReportEmails;
    }
  }
};
</script>

<style lang="scss" scoped>
.oil-sample-report .contextual-info .element-key .element-table {
  grid-template-columns: repeat(9, 60px);
}
</style>
